// Local translations
export const T = {
  en_GB: {
    edit: "Edit",
    productDocumentTypes: "Product Document Types",
    description:
      "Define document types that can be attached to products (e.g., KIID, Fact Sheet, Prospectus). Optionally configure Morningstar Document Library mapping for automatic document lookup.",
    noDocumentTypes: 'No document types configured. Click "Add Document Type" to create one.',
    name: "Name",
    morningstarMapping: "Morningstar Mapping",
    active: "Active",
    actions: "Actions",
    notConfigured: "Not configured",
    type: "Type",
    market: "Market",
    addDocumentType: "Add Document Type",
    deleteDocumentType: "Delete Document Type",
    deleteConfirmation:
      "Are you sure you want to delete this document type? This action cannot be undone.",
    delete: "Delete",
    cancel: "Cancel",
    error: "Error",
    failedToDelete: "Failed to delete document type",
    failedToUpdate: "Failed to update document type",
  },
  nb_NO: {
    edit: "Rediger",
    productDocumentTypes: "Produktdokumenttyper",
    description:
      "Definer dokumenttyper som kan legges ved produkter (f.eks. KIID, Faktaark, Prospekt). Konfigurer eventuelt Morningstar Document Library-kobling for automatisk dokumentoppslag.",
    noDocumentTypes:
      'Ingen dokumenttyper konfigurert. Klikk "Legg til dokumenttype" for å opprette en.',
    name: "Navn",
    morningstarMapping: "Morningstar-kobling",
    active: "Aktiv",
    actions: "Handlinger",
    notConfigured: "Ikke konfigurert",
    type: "Type",
    market: "Marked",
    addDocumentType: "Legg til dokumenttype",
    deleteDocumentType: "Slett dokumenttype",
    deleteConfirmation:
      "Er du sikker på at du vil slette denne dokumenttypen? Denne handlingen kan ikke angres.",
    delete: "Slett",
    cancel: "Avbryt",
    error: "Feil",
    failedToDelete: "Kunne ikke slette dokumenttype",
    failedToUpdate: "Kunne ikke oppdatere dokumenttype",
  },
} as const;
